function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.799384 38.977C0.00583887 40.3102 0.966515 42 2.51797 42H45.482C47.0335 42 47.9942 40.3102 47.2006 38.977L25.7186 2.88722C24.9432 1.58451 23.0568 1.58451 22.2814 2.88722L0.799384 38.977Z",
  fill: "#EB5757"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.1666 36.0001V34.1281H25.6546V19.3201H23.6866L19.0786 22.1761V24.3601L23.5906 21.6481V34.1281H19.0546V36.0001H30.1666Z",
  fill: "white"
});

var Svg1High = function Svg1High(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg1High, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/1-high.b2899d93.svg";
export { ForwardRef as ReactComponent };